<ng-container *ngIf="!!params">
    <tt-select
        ttLabel="planpolicy_no"
        [(ttModel)]="params.planpolicy_no"
        (ttModelChange)="onChanged('planpolicy_no')"
        [ttData]="planPolicies"
        ttDataId="planpolicy_no"
        ttDataName="planpolicy_name"
    ></tt-select>
    <ng-container *ngIf="params.prodtype_no === '0' || params.prodtype_no === '3'">
        <tt-checkbox ttLabel="use_est_deliverydate_to_stock" [(ttModel)]="params.use_est_deliverydate_to_stock" (ttModelChange)="onChanged('use_est_deliverydate_to_stock')"></tt-checkbox>
        <tt-date
            [hidden]="'' + params.use_est_deliverydate_to_stock !== '1'"
            ttLabel="est_deliverydate_to_stock"
            [(ttModel)]="params.est_deliverydate_to_stock"
            (ttModelChange)="onChanged('est_deliverydate_to_stock')"
        ></tt-date>
    </ng-container>

    <ng-container *ngIf="params.planpolicy_no === '2'">
        <tt-select
            ttLabel="pohcompletionprinciple_keyno"
            [(ttModel)]="params.pohcompletionprinciple_keyno"
            (ttModelChange)="onChanged('pohcompletionprinciple_keyno')"
            [ttData]="completionPrinciples"
            ttDataId="pohcompletionprinciple_keyno"
            ttDataName="pohcompletionprinciple_name"
        ></tt-select>
        <tt-checkbox ttLabel="manage_stockquantity_pr_batch" [(ttModel)]="params.manage_stockquantity_pr_batch" (ttModelChange)="onChanged('manage_stockquantity_pr_batch')"></tt-checkbox>
        <tt-input-number
            [hidden]="'' + params.manage_stockquantity_pr_batch !== '1'"
            ttLabel="stockquantity_pr_batch"
            [(ttModel)]="params.stockquantity_pr_batch"
            (ttModelChange)="onChanged('stockquantity_pr_batch')"
            ttTextAlign="right"
            ttDecimals="2"
        ></tt-input-number>
    </ng-container>
    <tt-select
        *ngIf="params.setting_show_carrier === '1'"
        ttLabel="carrier"
        [(ttModel)]="params.carrier_keyno"
        (ttModelChange)="onChanged('carrier_keyno')"
        [ttData]="carriers"
        ttDataId="carrier_keyno"
        ttDataName="carrier_name"
    ></tt-select>
    <tt-input-number
        *ngIf="params.show_units_pr_carrier === '1'"
        ttLabel="units_pr_carrier"
        [(ttModel)]="params.units_pr_carrier"
        (ttModelChange)="onChanged('units_pr_carrier')"
        ttTextAlign="right"
        ttDecimals="2"
    ></tt-input-number>
    <tt-input-number
        *ngIf="params.show_place_factor === '1'"
        ttLabel="place_factor"
        [(ttModel)]="params.place_factor"
        (ttModelChange)="onChanged('place_factor')"
        ttTextAlign="right"
        ttDecimals="2"
    ></tt-input-number>
    <tt-input ttLabel="ean_list" [(ttModel)]="params.ean_list" ttReadonly>
        <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="producteans" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-form-field-button>
    </tt-input>
</ng-container>
